import { ICompileService } from "angular";
import { StateService } from "@uirouter/angularjs";
import { RecordDataSource } from "../../../records/grids";

import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";

import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";

import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

import { IQuery } from "../../../records/server/query";

import { ColDef } from "../../../records/grids/columns/colDef";

const gridId = Symbol("main.user.grid");

export class UserGridComponentController {

  static $inject = [
    ServerUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
    "$state",
  ];

  public showActiveOnly: boolean = true;

  public readonly gridSettings: IGridSettings;

  public readonly columns: ColDef[];

  public readonly defaultQuery: IQuery = {
    Locked: false,
  };

  public readonly gridDataSource: RecordDataSource;

  constructor(
    serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService,
    private readonly $state: StateService
  ) {

    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/user/detail"
    );

    this.gridSettings =
      gridSettingsService.getGridSettings(gridId);

    this.columns = [

      this.columnDefinitionService.getNumberColDef({
        field: "UserAuthId",
        header: "User Id",
        hide: true,
      }),

      this.columnDefinitionService.getStringColDef({
        field: "UserName",
        header: "Username",
      }),

      this.columnDefinitionService.getStringColDef({
        field: "Email",
      }),

      this.columnDefinitionService.getStringColDef({
        field: "FirstName",
      }),

      this.columnDefinitionService.getStringColDef({
        field: "LastName",
      }),

      this.columnDefinitionService.getNumberColDef({
        field: "InvalidLoginAttempts",
      }),

      this.columnDefinitionService.getDateTimeColDef({
        field: "LastLoginAttempt",
      }),

      this.columnDefinitionService.getDateTimeColDef({
        field: "LockedDate",
      }),
    ];
  }

  public onAddNew(): void {
    this.$state.go("^.add");
  }

  public toggleActiveOnly(): void {

    this.defaultQuery.Locked =
      !this.showActiveOnly;
  }
}